/**
 *  Custom Collection Tabs – Promo Switcher
 *
 *  Listens for tab clicks inside each custom-collection-tabs section
 *  and toggles the matching promo panel via data-promo-index.
 *
 *  Does NOT modify or replace collection-tabs.js.
 */

(function () {
  'use strict';

  /*
   *  Prevent Accidental Misclicks / Redirects
   *  This specifically blocks the tab buttons from accidentally triggering
   *  underlying or overlapping links (like blog articles) during clicks/swipes.
   */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.custom-collection-tabs .collection-tabs__list-link')) {
      // If JS hasn't fully attached or the user misclicked on an overlapping area,
      // this stops the browser from actually following an <a> tag redirect.
      e.preventDefault();
    }
  }, true); // useCapture = true (runs first)

  function initCustomCollectionTabs() {
    var sections = document.querySelectorAll('.custom-collection-tabs');

    sections.forEach(function (section) {
      var tabContainer = section.querySelector('collection-tabs');
      if (!tabContainer) return;

      var promoColumn = section.querySelector('.custom-collection-tabs__promo-column');
      if (!promoColumn) return;

      var promoItems = promoColumn.querySelectorAll('.promo-item[data-promo-index]');
      if (!promoItems.length) return;

      /**
       * Show the promo matching the given tab index, hide all others.
       */
      function showPromo(index) {
        promoItems.forEach(function (item) {
          if (parseInt(item.getAttribute('data-promo-index'), 10) === index) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      }

      /**
       * Determine the active tab index from the button list.
       */
      function getActiveIndex(buttons) {
        for (var i = 0; i < buttons.length; i++) {
          if (buttons[i].classList.contains('active')) {
            return i;
          }
        }
        return 0;
      }

      // Use a short timeout to match collection-tabs.js initialisation timing
      setTimeout(function () {
        var buttons = tabContainer.querySelectorAll('button');
        if (!buttons.length) return;

        // Set initial promo
        showPromo(getActiveIndex(buttons));

        // Listen for tab clicks
        buttons.forEach(function (button, i) {
          button.addEventListener('click', function () {
            showPromo(i);
          });
        });
      }, 30); // slightly after collection-tabs.js (20ms)
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomCollectionTabs);
  } else {
    initCustomCollectionTabs();
  }

  // Also handle Shopify theme editor section load/select events
  document.addEventListener('shopify:section:load', initCustomCollectionTabs);
  document.addEventListener('shopify:section:select', initCustomCollectionTabs);

  // Scroll clicked tab button to center of the list
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.collection-tabs__list-link');
    if (!btn) return;
    
    var container = btn.closest('collection-tabs, .collection-tabs__list');
    if (container) {
      var scrollLeft = btn.offsetLeft - (container.clientWidth / 2) + (btn.clientWidth / 2);
      container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    } else {
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
})();
